module.exports = __webpack_public_path__ + "img/3lmsmwkim1lyd_o.54a76fd4.png";